import { z } from "zod";

export const SHIFT_PRODUCTION_FORM_API_BASE = "/api/shift-production-form";
export const SHIFT_PRODUCTION_FORM_SLUG = "/vardiya-uretim-formu";
export const SHIFT_FORM_OPERATOR_COOKIE = "anl_shift_form_operator";
export const SHIFT_FORM_APPROVER_COOKIE = "anl_shift_form_approver";
export const SHIFT_FORM_APPROVAL_TEMPLATE_KEY = "shift-production-form-approval";
export const SHIFT_FORM_APPROVAL_DAILY_BATCH_TEMPLATE_KEY = "shift-production-form-approval-daily-batch";
export const shiftProductionDepartmentNames = [
  "ÇİKOLATA",
  "LİCORİCE",
  "KORNET / GOFRET",
  "HAMURHANE (BİLYALILAR)",
] as const;
export const shiftProductionDepartmentNameSchema = z.enum(shiftProductionDepartmentNames);

export const shiftProductionLineNames = [
  "MEMET - 1",
  "MEMET - 2",
  "MEMET - 3",
  "PVC",
  "FND - 1",
  "FND - 2",
  "FND - 3",
  "FND - 4",
  "FND - 5",
  "FND - 6",
  "FND - 7",
  "FND - 8",
  "FND - 9",
  "ACMA GD",
  "LİCORİCE - 1",
  "LİCORİCE 1 - İMAR",
  "LİCORİCE 1 - KASE",
  "LİCORİCE 1 - FLOWPACK",
  "LİCORİCE - 2",
  "LİCORİCE 2 - ROLL",
  "LİCORİCE 2 - FLOWPACK",
  "LİCORİCE 2 - KASE",
  "LİCORİCE - FND",
  "LİCORİCE DİKEY - SEYHAN",
  "LİCORİCE DİKEY - ÇİN",
  "WAFINO - 1",
  "WAFINO - 2",
  "GOFRET - FIRIN",
  "GOFRET - OPM",
  "GOFRET - ASTRA",
  "BİLYALI - 1",
  "BİLYALI - 2",
  "BİLYALI - 3",
  "BİLYALI - 4",
  "BİLYALI - 5",
  "BİLYALI - 6",
  "BİLYALI - 7",
  "BİLYALI - 8",
  "BİLYALI - 9",
  "BİLYALI - 10",
  "BİLYALI - 11",
  "BİLYALI - 12",
] as const;

export const shiftProductionLinesByDepartment = {
  "ÇİKOLATA": [
    "MEMET - 1", "MEMET - 2", "MEMET - 3", "PVC",
    "FND - 1", "FND - 2", "FND - 3", "FND - 4", "FND - 5",
    "FND - 6", "FND - 7", "FND - 8", "FND - 9", "ACMA GD",
  ],
  "LİCORİCE": [
    "LİCORİCE - 1", "LİCORİCE 1 - İMAR", "LİCORİCE 1 - KASE", "LİCORİCE 1 - FLOWPACK",
    "LİCORİCE - 2", "LİCORİCE 2 - ROLL", "LİCORİCE 2 - FLOWPACK", "LİCORİCE 2 - KASE",
    "LİCORİCE - FND", "LİCORİCE DİKEY - SEYHAN", "LİCORİCE DİKEY - ÇİN",
  ],
  "KORNET / GOFRET": [
    "WAFINO - 1", "WAFINO - 2", "GOFRET - FIRIN", "GOFRET - OPM", "GOFRET - ASTRA",
  ],
  "HAMURHANE (BİLYALILAR)": [
    "BİLYALI - 1", "BİLYALI - 2", "BİLYALI - 3", "BİLYALI - 4",
    "BİLYALI - 5", "BİLYALI - 6", "BİLYALI - 7", "BİLYALI - 8",
    "BİLYALI - 9", "BİLYALI - 10", "BİLYALI - 11", "BİLYALI - 12",
  ],
} as const satisfies Record<
  (typeof shiftProductionDepartmentNames)[number],
  readonly (typeof shiftProductionLineNames)[number][]
>;

// Historical forms and approval settings retain their original line identity.
export const retiredShiftProductionLineNames = [
  "AMBALAJ - FOLYO YUMURTA",
  "ÖZDEPACK - FOLYO YUMURTA",
  "DOYPACK WAFINO",
  "ELLE AMBALAJ",
  "ELLE PAKETLEME",
  "AMBALAJ 4 - BÜYÜK FİGÜR",
  "AMBALAJ 5 - BÜYÜK YUMURTA",
  "AMBALAJ 6 - 38G FİGÜR",
  "ED1",
  "ED2",
  "ASTRA DİKEY PAKETLEME",
  "KORNET",
  "PVC YUMURTA",
  "TAMTAŞ SİLİNDİR",
  "TAMTAŞ POŞET",
  "ÇİN POŞET LEXUS",
  "HAT - 4",
  "HAT - 5",
  "HAT - 6",
  "HAT - 7",
  "GOFRET",
  "FND - FOLYO",
] as const;
export const shiftProductionLineNameSchema = z.enum([
  ...shiftProductionLineNames,
  ...retiredShiftProductionLineNames,
]);
export const shiftCodeSchema = z.enum(["00_08", "08_16", "16_00"]);
export const formStatusSchema = z.enum([
  "DRAFT",
  "RETURNED",
  "PENDING_SHIFT_SUPERVISOR",
  "PENDING_PRODUCTION_ENGINEER",
  "PENDING_PRODUCTION_MANAGER",
  "COMPLETED",
]);
export const approvalStageSchema = z.enum([
  "SHIFT_SUPERVISOR",
  "PRODUCTION_ENGINEER",
  "PRODUCTION_MANAGER",
]);
export const measurementStateSchema = z.enum([
  "MEASURED",
  "NOT_MEASURED",
  "NOT_APPLICABLE",
]);
export const missingMeasurementReasonSchema = z.enum([
  "DEVICE_FAILURE",
  "DEVICE_UNAVAILABLE",
  "MEASUREMENT_INACCESSIBLE",
  "OTHER",
]);
export const checklistStateSchema = z.enum([
  "SUITABLE",
  "UNSUITABLE",
  "NOT_CHECKED",
  "NOT_APPLICABLE",
]);

const idSchema = z.string().uuid();
const dateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/u)
  .refine((value) => {
    const [year, month, day] = value.split("-").map(Number);
    if (year === undefined || month === undefined || day === undefined) return false;
    const parsed = new Date(Date.UTC(year, month - 1, day));
    return parsed.getUTCFullYear() === year && parsed.getUTCMonth() === month - 1 && parsed.getUTCDate() === day;
  }, "Geçerli bir takvim tarihi girilmelidir.");
const instantSchema = z.string().datetime({ offset: true });
const localTimeSchema = z.string().regex(/^(?:[01]\d|2[0-3]):[0-5]\d$/u);
const optionalTextSchema = z.string().trim().max(2_000).default("");
const nullableNonNegativeNumber = z.number().finite().nonnegative().nullable();

const documentMetadataFields = {
  documentNo: z.string().trim().max(120).nullable(),
  publicationDate: dateSchema,
  revisionDate: dateSchema,
  revisionNo: z.string().trim().max(120).nullable(),
};
export const shiftFormDocumentSettingsSchema = z.object({
  ...documentMetadataFields,
  version: z.number().int().positive(),
  updatedAt: instantSchema,
  updatedBy: idSchema.nullable(),
});
export const shiftFormDocumentSettingsResponseSchema = z.object({
  settings: shiftFormDocumentSettingsSchema,
});
export const saveShiftFormDocumentSettingsRequestSchema = z.object({
  ...documentMetadataFields,
  expectedVersion: z.number().int().positive(),
});

export const checklistItemSchema = z.object({
  key: z.enum([
    "TANK_AND_PIPING",
    "MOVING_PARTS",
    "GUARDS_SENSORS_SWITCHES",
    "MOLD",
    "REEL_PACKAGING_LABEL_BOX",
  ]),
  state: checklistStateSchema.nullable(),
  explanation: optionalTextSchema,
});

export const measurementSchema = z.object({
  key: z.enum([
    "THEORETICAL_LINE_SPEED",
    "ACTUAL_LINE_SPEED",
    "MACHINE_TEMPERATURE",
    "OVEN_TEMPERATURE",
    "MOLD_TEMPERATURE",
    "TUNNEL_TEMPERATURE",
    "UNIT_WEIGHT",
    "PRODUCT_MOISTURE",
    "AMBIENT_TEMPERATURE",
    "AMBIENT_HUMIDITY",
  ]),
  state: measurementStateSchema.nullable(),
  value: z.number().finite().nullable(),
  unit: z.string().trim().max(40).nullable(),
  measuredAt: instantSchema.nullable(),
  pointOrMethod: z.string().trim().max(240).nullable(),
  missingReason: missingMeasurementReasonSchema.nullable(),
  explanation: z.string().trim().max(1_000).nullable(),
});

const eventIdSchema = z.string().uuid().optional();
export const speedChangeSchema = z.object({
  id: eventIdSchema,
  // Kept for previously saved records. The PDF speed-change row has no time field.
  occurredAt: instantSchema.nullable().default(null),
  newSpeed: nullableNonNegativeNumber,
  unit: z.string().trim().max(40).nullable(),
  reason: z.string().trim().max(1_000),
  informedPerson: z.string().trim().max(200).nullable(),
  // Kept for historical records. New rows always name the informed person.
  notInformed: z.boolean().default(false),
});
export const downtimeSchema = z.object({
  id: eventIdSchema,
  startedAt: instantSchema.nullable(),
  endedAt: instantSchema.nullable(),
  // Historical compatibility only; the PDF has a direct end-time field.
  carriedToNextShift: z.boolean().default(false),
  reason: z.string().trim().max(1_000),
  responsibleDepartment: z.string().trim().max(200),
  // Historical compatibility only; the PDF has a direct ticket-number field.
  maintenanceRequested: z.boolean().default(false),
  maintenanceTicketNo: z.string().trim().max(120).nullable(),
});
export const productChangeSchema = z.object({
  id: eventIdSchema,
  // These four fields were used by an earlier digital-only row. Keep them
  // optional for old snapshots; new PDF rows use only reason/count/department.
  previousProduct: z.string().trim().max(300).default(""),
  nextProduct: z.string().trim().max(300).default(""),
  reason: z.string().trim().max(1_000),
  participantCount: z.number().int().nonnegative().nullable(),
  responsibleDepartment: z.string().trim().max(200),
  restartAt: instantSchema.nullable().default(null),
  firstProductAt: instantSchema.nullable().default(null),
});

const quantitiesSchema = z.object({
  scrapKg: nullableNonNegativeNumber,
  animalFeedKg: nullableNonNegativeNumber,
  reelWasteQuantity: nullableNonNegativeNumber,
  boxWasteCount: z.number().int().nonnegative().nullable(),
  cartonWasteCount: z.number().int().nonnegative().nullable(),
  labelWasteCount: z.number().int().nonnegative().nullable(),
  targetCarton: nullableNonNegativeNumber,
  targetCount: z.number().int().nonnegative().nullable(),
  targetKg: nullableNonNegativeNumber,
  actualCarton: nullableNonNegativeNumber,
  actualCount: z.number().int().nonnegative().nullable(),
  actualKg: nullableNonNegativeNumber,
  targetNotDefined: z.boolean().default(false),
  targetExplanation: z.string().trim().max(1_000).nullable(),
  wasteReason: z.string().trim().max(1_000).nullable(),
  wasteResponsibleDepartment: z.string().trim().max(200).nullable(),
});

export const productSectionSchema = z.object({
  id: eventIdSchema,
  productionOccurred: z.boolean().default(true),
  noProductionReason: z.string().trim().max(1_000).nullable().default(null),
  // Legacy product metadata is retained in snapshots but no longer required.
  productName: z.string().trim().max(300).default(""),
  productCode: z.string().trim().max(120).nullable().default(null),
  workOrderNo: z.string().trim().max(120).nullable().default(null),
  machineStartedAt: instantSchema.nullable().default(null),
  machineStartNotOccurredReason: z.string().trim().max(1_000).nullable().default(null),
  firstProductAt: instantSchema.nullable().default(null),
  firstProductNotOccurredReason: z.string().trim().max(1_000).nullable().default(null),
  delayed: z.boolean().default(false),
  delayReason: z.string().trim().max(1_000).nullable().default(null),
  moldCount: z.number().int().nonnegative().nullable().default(null),
  moldSuitable: z.boolean().nullable().default(null),
  speedDeviationReason: z.string().trim().max(1_000).nullable(),
  postChangeMachineStartedAt: instantSchema.nullable().default(null),
  postChangeDelayReason: z.string().trim().max(1_000).nullable().default(null),
  postChangeFirstProductAt: instantSchema.nullable().default(null),
  postChangeFirstProductDelayReason: z.string().trim().max(1_000).nullable().default(null),
  measurements: z.array(measurementSchema).max(20),
  speedChanges: z.array(speedChangeSchema).max(200),
  downtimes: z.array(downtimeSchema).max(200),
  productChanges: z.array(productChangeSchema).max(100),
  quantities: quantitiesSchema,
  explanation: optionalTextSchema,
});

export const shiftProductionFormPayloadSchema = z.object({
  documentNo: z.string().trim().max(120).nullable().default(null),
  publicationDate: dateSchema.nullable().default(null),
  revisionDate: dateSchema.nullable().default(null),
  revisionNo: z.string().trim().max(120).nullable().default(null),
  operatorName: z.string().trim().max(200),
  departmentName: shiftProductionDepartmentNameSchema.nullable().default(null),
  lineName: shiftProductionLineNameSchema.nullable(),
  productionDate: dateSchema.nullable(),
  shift: shiftCodeSchema.nullable(),
  checklist: z.array(checklistItemSchema).max(20),
  checklistExplanation: optionalTextSchema,
  products: z.array(productSectionSchema).max(100),
  generalExplanation: optionalTextSchema,
  lateCompletionReason: z.string().trim().max(1_000).nullable().default(null),
});

export const createShiftProductionFormRequestSchema = z.object({
  payload: shiftProductionFormPayloadSchema,
  idempotencyKey: z.string().uuid(),
});
export const updateShiftProductionFormRequestSchema = z.object({
  expectedVersion: z.number().int().positive(),
  payload: shiftProductionFormPayloadSchema,
});
export const submitShiftProductionFormRequestSchema = z.object({
  expectedVersion: z.number().int().positive(),
});
export const reviseShiftProductionFormRequestSchema = z.object({
  expectedVersion: z.number().int().positive(),
});
export const shiftFormCorrectionTargetSchema = z.object({
  field: z.string().trim().min(1).max(200),
  instruction: z.string().trim().min(1).max(1_000),
});
export const decideShiftProductionFormRequestSchema = z.object({
  expectedVersion: z.number().int().positive(),
  revisionNumber: z.number().int().positive(),
  action: z.literal("APPROVE"),
  explanation: z.string().trim().max(2_000).nullable(),
  missingMeasurementAcceptanceReason: z.string().trim().max(2_000).nullable(),
});

export const shiftFormActorSchema = z.object({
  kind: z.enum(["OPERATOR", "APPROVER", "CORPORATE"]),
  id: idSchema,
  name: z.string(),
  email: z.string().email().nullable(),
  administrator: z.boolean(),
  analysisAccess: z.boolean().default(false),
});
export const shiftFormSessionResponseSchema = z.object({
  actor: shiftFormActorSchema.nullable(),
  expiresAt: instantSchema.nullable(),
  idleExpiresAt: instantSchema.nullable(),
});
export const operatorLoginRequestSchema = z.object({ pin: z.string().regex(/^\d{4}$/u) });
export const operatorLoginResponseSchema = shiftFormSessionResponseSchema;
export const approverLoginRequestSchema = z.object({ pin: z.string().regex(/^\d{6}$/u) });
export const approverLoginResponseSchema = shiftFormSessionResponseSchema;

export const approvalDecisionSchema = z.object({
  id: idSchema,
  revisionNumber: z.number().int().positive(),
  stage: approvalStageSchema,
  decision: z.enum(["APPROVED", "RETURNED"]),
  actorId: idSchema,
  actorName: z.string(),
  explanation: z.string().nullable(),
  correctionTargets: z.array(shiftFormCorrectionTargetSchema).max(50).default([]),
  missingMeasurementAcceptanceReason: z.string().nullable(),
  decidedAt: instantSchema,
});
export const shiftProductionFormHistoryEventSchema = z.object({
  id: idSchema,
  eventType: z.string(),
  actorKind: z.enum(["OPERATOR", "CORPORATE", "SYSTEM"]),
  actorId: idSchema.nullable(),
  actorName: z.string(),
  revisionNumber: z.number().int().positive(),
  reason: z.string().nullable(),
  previousState: z.record(z.string(), z.unknown()).nullable(),
  nextState: z.record(z.string(), z.unknown()).nullable(),
  occurredAt: instantSchema,
});
export const shiftProductionFormRevisionSchema = z.object({
  revisionNumber: z.number().int().positive(),
  snapshot: shiftProductionFormPayloadSchema,
  submittedByOperatorId: idSchema,
  submittedAt: instantSchema,
});
export const shiftProductionFormSchema = z.object({
  id: idSchema,
  formNo: z.string(),
  ownerOperatorId: idSchema,
  status: formStatusSchema,
  version: z.number().int().positive(),
  revisionNumber: z.number().int().positive(),
  payload: shiftProductionFormPayloadSchema,
  hasMissingMeasurements: z.boolean(),
  submittedSnapshot: shiftProductionFormPayloadSchema.nullable(),
  currentApprovalStage: approvalStageSchema.nullable(),
  assignmentState: z.enum(["ASSIGNED", "UNASSIGNED"]),
  currentAssignedUserId: idSchema.nullable(),
  canDecide: z.boolean(),
  decisions: z.array(approvalDecisionSchema),
  revisions: z.array(shiftProductionFormRevisionSchema),
  history: z.array(shiftProductionFormHistoryEventSchema),
  createdAt: instantSchema,
  updatedAt: instantSchema,
  submittedAt: instantSchema.nullable(),
  completedAt: instantSchema.nullable(),
});
export const shiftProductionFormListItemSchema = shiftProductionFormSchema.pick({
  id: true,
  formNo: true,
  ownerOperatorId: true,
  status: true,
  version: true,
  revisionNumber: true,
  hasMissingMeasurements: true,
  currentApprovalStage: true,
  assignmentState: true,
  currentAssignedUserId: true,
  createdAt: true,
  updatedAt: true,
  submittedAt: true,
  completedAt: true,
}).extend({
  operatorName: z.string(),
  lineName: shiftProductionLineNameSchema.nullable(),
  productionDate: dateSchema.nullable(),
  shift: shiftCodeSchema.nullable(),
  previewPayload: shiftProductionFormPayloadSchema.optional(),
});
export const shiftProductionFormListResponseSchema = z.object({
  items: z.array(shiftProductionFormListItemSchema),
  total: z.number().int().nonnegative(),
});
export const shiftProductionFormResponseSchema = z.object({ form: shiftProductionFormSchema });
export const operatorDraftResponseSchema = z.object({ form: shiftProductionFormSchema.nullable() });
export const linesResponseSchema = z.object({ items: z.array(shiftProductionLineNameSchema) });
export const shiftFormLineUnitsResponseSchema = z.object({
  items: z.array(z.object({
    lineName: shiftProductionLineNameSchema,
    speedUnit: z.string().trim().min(1).max(40),
    notApplicableMeasurementKeys: z.array(measurementSchema.shape.key),
  })),
});
export type ShiftFormLineUnits = z.infer<typeof shiftFormLineUnitsResponseSchema>["items"];
export const shiftFormApprovalNotificationPayloadSchema = z.object({
  formId: idSchema,
  formNo: z.string(),
  lineName: shiftProductionLineNameSchema,
  productionDate: dateSchema,
  shift: shiftCodeSchema,
  operatorName: z.string(),
  revisionNumber: z.number().int().positive(),
  stage: approvalStageSchema,
  actionUrl: z.string().url(),
  recipientName: z.string(),
  departmentName: shiftProductionDepartmentNameSchema.nullable().optional(),
  attentionCounts: z.object({
    downtime: z.number().int().nonnegative(),
    unsuitable: z.number().int().nonnegative(),
  }).nullable().optional(),
});

export const shiftFormApprovalDailyBatchPayloadSchema = z.object({
  batchDate: dateSchema,
  scheduledSendTime: localTimeSchema,
  stage: approvalStageSchema,
  actionUrl: z.string().url(),
  recipientName: z.string().trim().min(1).max(200),
  formCount: z.number().int().positive(),
  oldestProductionDate: dateSchema,
  newestProductionDate: dateSchema,
  departmentSummaries: z.array(z.object({
    departmentName: shiftProductionDepartmentNameSchema.nullable(),
    formCount: z.number().int().positive(),
  })).min(1),
});

export const shiftFormApprovalScheduleSettingsSchema = z.object({
  sendTime: localTimeSchema,
  timeZone: z.literal("Europe/Istanbul"),
  version: z.number().int().positive(),
  updatedAt: instantSchema,
  updatedBy: idSchema.nullable(),
});
export const shiftFormApprovalScheduleSettingsResponseSchema = z.object({
  settings: shiftFormApprovalScheduleSettingsSchema,
});
export const updateShiftFormApprovalScheduleSettingsRequestSchema = z.object({
  sendTime: localTimeSchema,
  expectedVersion: z.number().int().positive(),
});

export const shiftFormDailyCoverageQuerySchema = z.object({
  productionDate: dateSchema,
  departmentName: shiftProductionDepartmentNameSchema.optional(),
});
export const shiftFormDailyCoverageSlotStatusSchema = z.enum([
  "NOT_SUBMITTED",
  "PENDING_APPROVAL",
  "APPROVED",
]);
export const shiftFormDailyCoverageResponseSchema = z.object({
  productionDate: dateSchema,
  departmentName: shiftProductionDepartmentNameSchema.nullable(),
  generatedAt: instantSchema,
  summary: z.object({
    submittedCount: z.number().int().nonnegative(),
    pendingApprovalCount: z.number().int().nonnegative(),
    approvedCount: z.number().int().nonnegative(),
    notSubmittedCount: z.number().int().nonnegative(),
  }),
  slots: z.array(z.object({
    departmentName: shiftProductionDepartmentNameSchema,
    lineName: shiftProductionLineNameSchema,
    shift: shiftCodeSchema,
    status: shiftFormDailyCoverageSlotStatusSchema,
    formId: idSchema.nullable(),
    formNo: z.string().nullable(),
    revisionNumber: z.number().int().positive().nullable(),
    currentApprovalStage: approvalStageSchema.nullable(),
    submittedAt: instantSchema.nullable(),
    completedAt: instantSchema.nullable(),
  })),
});

const optionalBooleanQuerySchema = z.preprocess((value) => {
  if (value === "true") return true;
  if (value === "false") return false;
  return value;
}, z.boolean().optional());

export const shiftFormListQuerySchema = z.object({
  view: z.enum(["mine", "pending", "processed", "accessible", "completed", "unassigned"]).default("mine"),
  stage: approvalStageSchema.optional(),
  approvedToday: optionalBooleanQuerySchema,
  search: z.string().trim().max(160).optional(),
  departmentName: shiftProductionDepartmentNameSchema.optional(),
  lineName: shiftProductionLineNameSchema.optional(),
  productionDate: dateSchema.optional(),
  dateFrom: dateSchema.optional(),
  dateTo: dateSchema.optional(),
  shift: shiftCodeSchema.optional(),
  operatorName: z.string().trim().max(200).optional(),
  status: formStatusSchema.optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
  offset: z.coerce.number().int().min(0).default(0),
}).superRefine((value, context) => {
  if (value.approvedToday !== undefined && value.view !== "processed") {
    context.addIssue({ code: "custom", path: ["approvedToday"], message: "Bugün onaylananlar yalnız işlenen form görünümünde filtrelenebilir." });
  }
  if (!value.dateFrom || !value.dateTo) return;
  const from = Date.parse(`${value.dateFrom}T00:00:00Z`);
  const to = Date.parse(`${value.dateTo}T00:00:00Z`);
  if (from > to) {
    context.addIssue({ code: "custom", path: ["dateTo"], message: "Bitiş tarihi başlangıç tarihinden önce olamaz." });
    return;
  }
  if ((to - from) / 86_400_000 >= 31) {
    context.addIssue({ code: "custom", path: ["dateTo"], message: "Form listesi tarih aralığı en fazla 31 gün olabilir." });
  }
});
export const shiftFormManagerDashboardQuerySchema = z.object({
  dateFrom: dateSchema.optional(),
  dateTo: dateSchema.optional(),
  departmentName: shiftProductionDepartmentNameSchema.optional(),
  lineName: shiftProductionLineNameSchema.optional(),
  shift: shiftCodeSchema.optional(),
  status: z.literal("COMPLETED").optional(),
  limit: z.coerce.number().int().min(1).max(500).default(200),
  offset: z.coerce.number().int().min(0).default(0),
}).superRefine((value, context) => {
  if (!value.dateFrom || !value.dateTo) return;
  const from = Date.parse(`${value.dateFrom}T00:00:00Z`);
  const to = Date.parse(`${value.dateTo}T00:00:00Z`);
  if (from > to) {
    context.addIssue({ code: "custom", path: ["dateTo"], message: "Bitiş tarihi başlangıç tarihinden önce olamaz." });
    return;
  }
  if ((to - from) / 86_400_000 >= 31) {
    context.addIssue({ code: "custom", path: ["dateTo"], message: "Rapor tarih aralığı en fazla 31 gün olabilir." });
  }
});

const managerQuantitySchema = z.object({
  unit: z.string().trim().min(1).max(40),
  value: z.number().finite().nonnegative(),
});
const managerWasteKeySchema = z.enum([
  "SCRAP",
  "ANIMAL_FEED",
  "REEL",
  "BOX",
  "CARTON",
  "LABEL",
]);
const managerWasteEntrySchema = managerQuantitySchema.extend({
  key: managerWasteKeySchema,
  label: z.string().trim().min(1).max(120),
});
const managerDowntimeSchema = z.object({
  reason: z.string().max(1_000),
  responsibleDepartment: z.string().max(200),
  durationMinutes: z.number().finite().nonnegative().nullable(),
});
const managerUnsuitableDetailSchema = z.object({
  key: checklistItemSchema.shape.key,
  explanation: z.string().max(2_000),
});
const managerReportStatusSchema = z.enum([
  "PENDING_SHIFT_SUPERVISOR",
  "PENDING_PRODUCTION_ENGINEER",
  "PENDING_PRODUCTION_MANAGER",
  "COMPLETED",
]);
const downtimeComparisonMetricsSchema = z.object({
  formCount: z.number().int().nonnegative(),
  missingDurationFormCount: z.number().int().nonnegative(),
  downtimeMinutes: z.number().finite().nonnegative().nullable(),
  averageDowntimeMinutes: z.number().finite().nonnegative().nullable(),
});
const downtimeComparisonShiftSchema = downtimeComparisonMetricsSchema.extend({ shift: shiftCodeSchema });
export const shiftFormDowntimeComparisonSchema = z.object({
  machines: z.array(downtimeComparisonMetricsSchema.extend({
    lineName: shiftProductionLineNameSchema,
    departmentName: shiftProductionDepartmentNameSchema.nullable(),
    shifts: z.array(downtimeComparisonShiftSchema),
  })),
  shifts: z.array(downtimeComparisonShiftSchema),
});
export type ShiftFormDowntimeComparison = z.infer<typeof shiftFormDowntimeComparisonSchema>;

const productionComparisonOutputSchema = managerQuantitySchema.extend({
  reportingFormCount: z.number().int().positive(),
});
const productionComparisonWasteEntrySchema = managerWasteEntrySchema.extend({
  reportingFormCount: z.number().int().positive(),
});
const productionComparisonShiftSchema = z.object({
  shift: shiftCodeSchema,
  formCount: z.number().int().nonnegative(),
  downtimeMinutes: z.number().finite().nonnegative().nullable(),
  actualOutputs: z.array(productionComparisonOutputSchema),
  wasteEntries: z.array(productionComparisonWasteEntrySchema),
});
export const shiftFormProductionComparisonSchema = z.object({
  machines: z.array(z.object({
    lineName: shiftProductionLineNameSchema,
    departmentName: shiftProductionDepartmentNameSchema.nullable(),
    formCount: z.number().int().nonnegative(),
    downtimeMinutes: z.number().finite().nonnegative().nullable(),
    actualOutputs: z.array(productionComparisonOutputSchema),
    wasteEntries: z.array(productionComparisonWasteEntrySchema),
    shifts: z.array(productionComparisonShiftSchema),
  })),
});
export type ShiftFormProductionComparison = z.infer<typeof shiftFormProductionComparisonSchema>;

const productionDailyTrendSchema = z.object({
  productionDate: dateSchema,
  formCount: z.number().int().nonnegative(),
  downtimeMinutes: z.number().finite().nonnegative().nullable(),
  actualOutputs: z.array(productionComparisonOutputSchema),
  wasteEntries: z.array(productionComparisonWasteEntrySchema),
});
export type ShiftFormProductionDailyTrend = z.infer<typeof productionDailyTrendSchema>;

const downtimeReasonBreakdownShiftSchema = z.object({
  shift: shiftCodeSchema,
  occurrenceCount: z.number().int().positive(),
  durationMinutes: z.number().finite().nonnegative().nullable(),
  sourceFormIds: z.array(idSchema).min(1),
});
const downtimeReasonBreakdownLineSchema = z.object({
  lineName: shiftProductionLineNameSchema,
  occurrenceCount: z.number().int().positive(),
  durationMinutes: z.number().finite().nonnegative().nullable(),
  shifts: z.array(downtimeReasonBreakdownShiftSchema),
});
const downtimeReasonBreakdownDepartmentSchema = z.object({
  departmentName: shiftProductionDepartmentNameSchema.nullable(),
  occurrenceCount: z.number().int().positive(),
  durationMinutes: z.number().finite().nonnegative().nullable(),
  lines: z.array(downtimeReasonBreakdownLineSchema),
});
const downtimeReasonBreakdownSchema = z.object({
  reasonKey: z.string().min(1).max(1_000),
  label: z.string().trim().min(1).max(1_000),
  occurrenceCount: z.number().int().positive(),
  durationMinutes: z.number().finite().nonnegative().nullable(),
  departments: z.array(downtimeReasonBreakdownDepartmentSchema),
});

export const shiftFormManagerDashboardResponseSchema = z.object({
  generatedAt: instantSchema,
  filters: z.object({
    dateFrom: dateSchema,
    dateTo: dateSchema,
    departmentName: shiftProductionDepartmentNameSchema.nullable(),
    lineName: shiftProductionLineNameSchema.nullable(),
    shift: shiftCodeSchema.nullable(),
  }),
  accessibleLineNames: z.array(shiftProductionLineNameSchema),
  coverage: z.object({
    totalMatchingForms: z.number().int().nonnegative(),
    returnedRows: z.number().int().nonnegative(),
    truncated: z.boolean(),
  }),
  summary: z.object({
    submittedFormCount: z.number().int().nonnegative(),
    pendingApprovalCount: z.number().int().nonnegative(),
    completedFormCount: z.number().int().nonnegative(),
    unsuitableFormCount: z.number().int().nonnegative(),
    downtimeRecordCount: z.number().int().nonnegative(),
    downtimeMinutes: z.number().finite().nonnegative().nullable(),
  }),
  rows: z.array(z.object({
    id: idSchema,
    formNo: z.string(),
    status: managerReportStatusSchema,
    revisionNumber: z.number().int().positive(),
    currentApprovalStage: approvalStageSchema.nullable(),
    productionDate: dateSchema,
    shift: shiftCodeSchema,
    departmentName: shiftProductionDepartmentNameSchema.nullable(),
    lineName: shiftProductionLineNameSchema,
    operatorName: z.string(),
    submittedAt: instantSchema,
    completedAt: instantSchema.nullable(),
    hasMissingMeasurements: z.boolean(),
    actualOutputs: z.array(managerQuantitySchema),
    downtimeMinutes: z.number().finite().nonnegative().nullable(),
    downtimes: z.array(managerDowntimeSchema),
    wasteEntries: z.array(managerWasteEntrySchema),
    unsuitableDetails: z.array(managerUnsuitableDetailSchema),
  })),
  analytics: z.object({
    actualOutputs: z.array(managerQuantitySchema),
    wasteEntries: z.array(managerWasteEntrySchema),
    downtimeComparison: shiftFormDowntimeComparisonSchema.optional(),
    productionComparison: shiftFormProductionComparisonSchema.optional(),
    // Complete ACL-filtered set before row pagination. Missing dates are not
    // synthesized here; callers render them explicitly as no-record days.
    dailyTrend: z.array(productionDailyTrendSchema).optional(),
    downtimeReasons: z.array(z.object({
      reason: z.string().max(1_000),
      responsibleDepartment: z.string().max(200),
      occurrenceCount: z.number().int().positive(),
      durationMinutes: z.number().finite().nonnegative().nullable(),
    })),
    // Kept optional so previously persisted/demo dashboard responses remain readable.
    // New report responses aggregate by a deterministic reason identity and retain
    // the exact authorized source-form path for reason → line → shift drill-down.
    reasonBreakdown: z.array(downtimeReasonBreakdownSchema).optional(),
  }),
});
export const operatorRecentSubmissionsQuerySchema = z.object({
  offset: z.coerce.number().int().min(0).default(0),
});

export const operatorPinRevealResponseSchema = z.object({ pin: z.string().regex(/^\d{4}$/u) });

export const operatorAdminSchema = z.object({
  pinRevealAvailable: z.boolean().default(false),
  id: idSchema,
  name: z.string(),
  active: z.boolean(),
  createdAt: instantSchema,
  pinChangedAt: instantSchema,
});
export const operatorAdminListResponseSchema = z.object({ items: z.array(operatorAdminSchema) });
export const createOperatorRequestSchema = z.object({ name: z.string().trim().min(1).max(200) });
export const operatorPinIssuedResponseSchema = z.object({
  operator: operatorAdminSchema,
  pin: z.string().regex(/^\d{4}$/u),
});
export const updateOperatorRequestSchema = z.object({ active: z.boolean() });
export const operatorAdminResponseSchema = z.object({ operator: operatorAdminSchema });
export const corporateUserOptionSchema = z.object({
  id: idSchema,
  name: z.string(),
  email: z.string().email(),
  active: z.boolean(),
  approverPinConfigured: z.boolean(),
  approverPinChangedAt: instantSchema.nullable(),
});
export const corporateUserOptionListResponseSchema = z.object({ items: z.array(corporateUserOptionSchema) });
export const approverPinIssuedResponseSchema = z.object({
  user: corporateUserOptionSchema,
  pin: z.string().regex(/^\d{6}$/u),
});

export const approvalAssignmentScopeSchema = z.discriminatedUnion("scopeType", [
  z.object({
    scopeType: z.literal("DEPARTMENT"),
    departmentName: shiftProductionDepartmentNameSchema,
    lineName: z.null(),
  }),
  z.object({
    scopeType: z.literal("LINE"),
    departmentName: shiftProductionDepartmentNameSchema,
    lineName: shiftProductionLineNameSchema,
  }).superRefine((value, context) => {
    if (!(shiftProductionLinesByDepartment[value.departmentName] as readonly string[]).includes(value.lineName)) {
      context.addIssue({ code: "custom", path: ["lineName"], message: "Makine seçilen bölüme ait olmalıdır." });
    }
  }),
]);
const approvalAssigneesSchema = z.object({
  SHIFT_SUPERVISOR: idSchema.nullable(),
  PRODUCTION_ENGINEER: idSchema.nullable(),
  PRODUCTION_MANAGER: idSchema.nullable(),
});
export const approvalAssignmentSchema = z.object({
  id: idSchema,
  scope: approvalAssignmentScopeSchema,
  viewerUserIds: z.array(idSchema),
  approvers: approvalAssigneesSchema,
  version: z.number().int().positive(),
  updatedAt: instantSchema,
  updatedBy: idSchema.nullable(),
});
export const approvalAssignmentListResponseSchema = z.object({
  defaults: z.array(approvalAssignmentSchema),
  lineOverrides: z.array(approvalAssignmentSchema),
});
export const saveApprovalAssignmentRequestSchema = z.object({
  scope: approvalAssignmentScopeSchema,
  viewerUserIds: z.array(idSchema),
  approvers: approvalAssigneesSchema,
  expectedVersion: z.number().int().nonnegative(),
  transferPendingForms: z.boolean(),
});
export const deleteApprovalAssignmentRequestSchema = z.object({
  scope: approvalAssignmentScopeSchema,
  expectedVersion: z.number().int().positive(),
  transferPendingForms: z.boolean(),
}).superRefine((value, context) => {
  if (value.scope.scopeType !== "LINE") {
    context.addIssue({ code: "custom", path: ["scope", "scopeType"], message: "Bölüm varsayılanı silinemez; güncellenmelidir." });
  }
});
export const saveApprovalAssignmentResponseSchema = z.object({
  item: approvalAssignmentSchema,
  transferredFormCount: z.number().int().nonnegative(),
});
export const deleteApprovalAssignmentResponseSchema = z.object({
  transferredFormCount: z.number().int().nonnegative(),
});
export const approvalMailStatusSchema = z.object({
  id: idSchema,
  formId: idSchema,
  formNo: z.string(),
  revisionNumber: z.number().int().positive(),
  stage: approvalStageSchema,
  recipient: z.string().email(),
  recipientName: z.string(),
  status: z.enum(["PENDING", "PROCESSING", "SENT", "FAILED", "DEAD", "CANCELLED"]),
  attemptCount: z.number().int().nonnegative(),
  maxAttempts: z.number().int().positive(),
  sentAt: instantSchema.nullable(),
  lastError: z.string().nullable(),
  createdAt: instantSchema,
});
export const approvalMailStatusListResponseSchema = z.object({ items: z.array(approvalMailStatusSchema) });

export const lineConfigurationSchema = z.object({
  lineName: shiftProductionLineNameSchema,
  visibleManagerUserIds: z.array(idSchema),
  approvers: z.object({
    SHIFT_SUPERVISOR: idSchema.nullable(),
    PRODUCTION_ENGINEER: idSchema.nullable(),
    PRODUCTION_MANAGER: idSchema.nullable(),
  }),
  speedUnit: z.string().trim().max(40).default("adet/dakika"),
  reelWasteUnit: z.string().trim().max(40).default("kg"),
  machineTemperaturePoint: z.string().trim().max(240).nullable(),
  productMoistureMethod: z.string().trim().max(240).nullable(),
  notApplicableMeasurementKeys: z.array(measurementSchema.shape.key),
  notApplicableChecklistKeys: z.array(checklistItemSchema.shape.key),
  version: z.number().int().positive(),
});
export const lineConfigurationListResponseSchema = z.object({ items: z.array(lineConfigurationSchema) });
export const lineConfigurationResponseSchema = z.object({ item: lineConfigurationSchema });
export const saveLineConfigurationRequestSchema = lineConfigurationSchema
  .omit({ lineName: true, version: true })
  .extend({ expectedVersion: z.number().int().nonnegative() });

export const adminReasonRequestSchema = z.object({
  expectedVersion: z.number().int().positive(),
  reason: z.string().trim().min(1).max(2_000),
});
export const transferFormRequestSchema = adminReasonRequestSchema.extend({
  newOperatorId: idSchema,
});
export const lateGrantRequestSchema = adminReasonRequestSchema.extend({
  expiresAt: instantSchema,
});
export const adminCreateFormRequestSchema = createShiftProductionFormRequestSchema.extend({
  operatorId: idSchema,
  reason: z.string().trim().min(1).max(2_000),
});

export type ShiftProductionFormPayload = z.infer<typeof shiftProductionFormPayloadSchema>;
export type ShiftProductionForm = z.infer<typeof shiftProductionFormSchema>;
export type ShiftProductionFormListItem = z.infer<typeof shiftProductionFormListItemSchema>;
export type ShiftFormManagerDashboard = z.infer<typeof shiftFormManagerDashboardResponseSchema>;
export type ShiftFormManagerDashboardFilters = z.input<typeof shiftFormManagerDashboardQuerySchema>;
export type ShiftFormManagerDashboardQuery = z.output<typeof shiftFormManagerDashboardQuerySchema>;
export type ShiftFormDailyCoverageQuery = z.output<typeof shiftFormDailyCoverageQuerySchema>;
export type ShiftFormDailyCoverage = z.infer<typeof shiftFormDailyCoverageResponseSchema>;
export type ShiftFormApprovalScheduleSettings = z.infer<typeof shiftFormApprovalScheduleSettingsSchema>;
export type UpdateShiftFormApprovalScheduleSettingsRequest = z.infer<typeof updateShiftFormApprovalScheduleSettingsRequestSchema>;
export type ShiftFormActor = z.infer<typeof shiftFormActorSchema>;
export type ApprovalStage = z.infer<typeof approvalStageSchema>;
export type ShiftProductionLineName = z.infer<typeof shiftProductionLineNameSchema>;
export type ShiftProductionDepartmentName = z.infer<typeof shiftProductionDepartmentNameSchema>;
export type ShiftFormDocumentSettings = z.infer<typeof shiftFormDocumentSettingsSchema>;
export type SaveShiftFormDocumentSettingsRequest = z.infer<typeof saveShiftFormDocumentSettingsRequestSchema>;
export type LineConfiguration = z.infer<typeof lineConfigurationSchema>;
export type SaveLineConfigurationRequest = z.infer<typeof saveLineConfigurationRequestSchema>;
export type ApprovalAssignment = z.infer<typeof approvalAssignmentSchema>;
export type ApprovalAssignmentScope = z.infer<typeof approvalAssignmentScopeSchema>;
export type SaveApprovalAssignmentRequest = z.infer<typeof saveApprovalAssignmentRequestSchema>;
export type DeleteApprovalAssignmentRequest = z.infer<typeof deleteApprovalAssignmentRequestSchema>;
export type ApprovalMailStatus = z.infer<typeof approvalMailStatusSchema>;
